import type { Translation } from "@/i18n/locales/types";

export const organization: Translation["organization"] = {
  title: "Organization",
  description: "Settings you rarely change.",
  domains: {
    title: "Google Workspace domains",
    description:
      "Only Google accounts from these domains can sign in. Besides the domain, each person has to be invited.",
    readOnly:
      "Domains are changed by Punto. Write to us if you need another one.",
  },
  retention: {
    title: "Log retention",
    description:
      "Signatures and browsing. Expired entries are deleted every night.",
    label: "Days kept",
    days_one: "{{count}} day",
    days_other: "{{count}} days",
    save: "Save",
    saved: "Retention saved: {{days}} days",
    errors: {
      range: "Between 30 and 3650 days.",
    },
  },
  admins: {
    title: "Admins",
    description:
      "They manage certificates, policies and people. To add one, change a person's role in People.",
    empty: "There are no admins.",
    manage: "Go to People",
  },
  support: {
    title: "Punto support access",
    description:
      "The Punto team can only get in if you grant it here, for a limited time. They can never sign, and everything they do is logged in Activity › Administration.",
    none: "No access granted.",
    grant: "Grant access…",
    grantTitle: "Grant support access",
    duration: "For",
    durations: {
      "24h": "24 hours",
      "3d": "3 days",
      "7d": "7 days",
    },
    access: "What they can do",
    accessOptions: {
      read_only: "View only",
      full: "View and change settings (never sign)",
    },
    email: "Punto person (optional)",
    emailPlaceholder: "Anyone on the support team",
    emailHint:
      "Leave it empty so whoever handles your case can enter; who enters is logged.",
    team: "Punto support team",
    reason: "Reason",
    reasonPlaceholder: "Check why the DGT site is being blocked",
    submit: "Grant",
    granted: "Access granted until {{when}}",
    active: "Active until {{when}}",
    columns: {
      who: "Who",
      access: "Access",
      reason: "Reason",
      until: "Until",
      status: "Status",
    },
    revoke: "Revoke",
    revokeTitle: "Revoke access for {{email}}?",
    revokeDescription:
      "Their support sessions are closed immediately. It is logged in Activity › Administration.",
    revokeConfirm: "Revoke now",
    revoked: "Access revoked",
    history: "Previous access",
    errors: {
      reason: "Explain what for.",
      email: "Enter a valid email.",
    },
  },
  catalog: {
    title: "Site catalog",
    summary: "Version {{version}} · {{domains}} domains in {{groups}} groups",
    description:
      "Certificates can only be used on these sites. Punto maintains it because it is tied to each Mac's CA.",
    view: "View",
    panelTitle: "Site catalog · version {{version}}",
    groupId: "In rules: {{id}}",
  },
  macApp: {
    title: "Mac app",
    description: "Download it and how to install it for your team.",
    download: "Download",
    noDownload: "Ask the Punto team for the installer.",
    steps: {
      one: "Download Punto.Firma and drag it to Applications.",
      two: "Open it and sign in with the organization's Google account.",
      three:
        "While it is open, the catalog sites use the allowed certificates.",
    },
  },
};
